import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { isOoriFastApiHealth, normalizeProductList } from "@/lib/apiHelpers";

const ApiStatusBanner = () => {
  const [bad, setBad] = useState(false);

  useEffect(() => {
    let cancelled = false;
    let attempts = 0;
    let retryTimer;

    const check = async () => {
      attempts += 1;
      try {
        // Prefer a real catalog probe — health alone used to false-alarm on DB blips.
        const products = await api.get("/products", { params: { limit: 1 }, timeout: 15000 });
        const items = normalizeProductList(products.data);
        if (!cancelled) setBad(items.length === 0);
        return;
      } catch {
        try {
          const health = await api.get("/health", { timeout: 10000 });
          if (!cancelled) setBad(!isOoriFastApiHealth(health.data));
          return;
        } catch {
          if (attempts < 3) {
            retryTimer = setTimeout(check, 2000 * attempts);
            return;
          }
          if (!cancelled) setBad(true);
        }
      }
    };

    let cancelStart;
    if (typeof requestIdleCallback === "function") {
      const idleId = requestIdleCallback(check, { timeout: 4000 });
      cancelStart = () => cancelIdleCallback(idleId);
    } else {
      const timer = setTimeout(check, 2500);
      cancelStart = () => clearTimeout(timer);
    }

    return () => {
      cancelled = true;
      cancelStart?.();
      if (retryTimer) clearTimeout(retryTimer);
    };
  }, []);

  if (!bad) return null;

  return (
    <div className="bg-amber-100 border-b border-amber-300 px-4 py-3 text-sm text-amber-950 text-center">
      Store catalog is temporarily unavailable — please refresh in a moment.
    </div>
  );
};

export default ApiStatusBanner;
